module.exports = __webpack_public_path__ + "static/media/UpLift_Logo.4c159363.svg";